export enum LayoutEnum {
  TWO_COLUMNS = "two_columns",
  THREE_COLUMNS = "three_columns",
}
